export const RULE_TYPES = [
  { value: "DETECT",     label: "DETECT — flag an irregularity" },
  { value: "ACCEPT_IF",  label: "ACCEPT IF — clinic policy, override AI flag" },
  { value: "REJECT_IF",  label: "REJECT IF — clinic policy, force a flag" },
  { value: "GOLD_MATCH", label: "GOLD MATCH — compare field to reference text" },
];

export const VERDICTS = [
  "Irregularity +ve",
  "CLARIFY",
  "NO Irregularity",
];

export const MATCH_MODES = [
  { value: "EXACT",    label: "EXACT — character-for-character match" },
  { value: "CLOSE",    label: "CLOSE — fuzzy similar wording allowed" },
  { value: "KEYWORDS", label: "KEYWORDS — all listed keywords must be present" },
];

// Common field names in the tokenised Communication Excel that DETECT and
// GOLD_MATCH rules can target. Free-typing is also allowed.
export const FIELD_OPTIONS = [
  "informed_consent",
  "procedure_done",
  "treatment_code",
  "treatment_plan",
  "narrative_diagnosis",
  "final_diagnosis",
  "chief_complaint",
  "hpi",
  "ros",
  "examination",
  "procedure_parameters",
  "patient_education",
  "doctor_notes_redacted",
  "icd_code",
  "skin_type",
  "hair_type",
  "age",
  "gender",
  "visit_date",
];

export function emptyRule() {
  return {
    type: "DETECT",
    active: true,
    title: "",
    description: "",
    when_field: "",
    when_alternatives: [""],
    also_requires: "",
    verdict: "Irregularity +ve",
    irregularity_site: "",
    irregularity_description: "",
    corrective_action: "",
    guideline_reference: "",
    applies_when_procedure_contains: "",
    match_field: "",
    expected_value: "",
    match_mode: "CLOSE",
    severity_if_mismatch: "Irregularity +ve",
    policy_statement: "",
    notes: "",
  };
}
